import { Loader2 } from 'lucide-react';

import { tv } from '@/utils/styles';

export interface InlineSpinnerProps {
  className?: string;
}

const InlineSpinner = ({ className = '' }: InlineSpinnerProps) => {
  const { base, spinner } = styles();

  return (
    <span className={base({ className })}>
      <Loader2 className={spinner()} />
    </span>
  );
};

const styles = tv({
  slots: {
    base: 'block h-4 w-4',
    spinner: 'h-full w-full animate-spin duration-1000',
  },
});

export { InlineSpinner };
